import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Distribution } from 'src/app/models/distribution.model'

@Injectable({
  providedIn: 'root',
})
export class DistributionService {
  public static readonly distributionEndpoint = '/distribution'

  constructor(private readonly http: HttpClient) {}

  getDistribution(fundId: string): Observable<Distribution> {
    return this.http.get<Distribution>(
      `vmf/api/${fundId}`.concat(DistributionService.distributionEndpoint),
    )
  }
}
